import { render } from "./singleAppointment.vue?vue&type=template&id=70b45fe8&scoped=true"
import script from "./singleAppointment.vue?vue&type=script&lang=js"
export * from "./singleAppointment.vue?vue&type=script&lang=js"

import "./singleAppointment.vue?vue&type=style&index=0&id=70b45fe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b45fe8"]])

export default __exports__